/**
 * Socket IO events for individually opened event (in dialog)
 */
export default {
  data () {
    return {
      connectedToEcho: false
    }
  },
  methods: {
    ioListen () {
      if (this.connectedToEcho || !this.id) {
        return
      }

      /**
       * Listen for any events on this invoice
       */

      this.$echo
        .private('Company.Client.' + this.id)
        .listen('.provider.sync', (e) => {
          if (!this.client) { return }

          // If sync finished
          if (!e.is_syncing) {
            if (e.refresh) {
              this.loadClient()
            }
            else {
              this.client.provider_details = e.provider_details
            }
          }
          else if (this.client.provider_details) {
            this.client.provider_details.is_syncing = true
          }
        })

      this.connectedToEcho = true
    },
    ioDisconnect () {
      this.$echo.leave('Company.Client.' + this.id)
      this.connectedToEcho = false
    }
  },
  beforeUnmount () {
    this.ioDisconnect()
  }
}
